import { render, staticRenderFns } from "./numberChart.vue?vue&type=template&id=3804482a&scoped=true"
import script from "./numberChart.vue?vue&type=script&lang=js"
export * from "./numberChart.vue?vue&type=script&lang=js"
import style0 from "./numberChart.vue?vue&type=style&index=0&id=3804482a&prod&scoped=true&lang=scss"
import style1 from "./numberChart.vue?vue&type=style&index=1&id=3804482a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804482a",
  null
  
)

export default component.exports